<template>
  <div class="col-md-12 col-lg-12 col-sm-12">
    <b-row>
      <b-col></b-col>
      <b-col lg="5" md="12" sm="12">
        <vue-select
          :placeholder="$t('home.searchRegion')"
          @search="fetchLocationType"
          class="style-v mb-2"
          v-model="locationTypeId"
          :options="listLocationType"
          :label="$localeKey()"
          :reduce="(item) => item.id"
        ></vue-select>
      </b-col>
      <b-col lg="5" md="12" sm="12">
        <vue-select
          :placeholder="$t('home.searchJob')"
          @search="fetchStaffPosition"
          class="style-v mb-2"
          v-model="staffPositionId"
          :options="listStaffPosition"
          :label="$localeKey()"
          :reduce="(item) => item.id"
        ></vue-select>
      </b-col>
      <b-col></b-col>
    </b-row>
    <div v-if="ennounsmentlistTotal > 0">
      <b-row>
        <b-col lg="12" md="12" sm="12">
          <b-overlay :show="loading" rounded="sm">
            <main>
              <ol class="gradient-list">
                <li
                  @click="vacancyPage(ennounsment.id)"
                  v-for="(ennounsment, index) in ennounsmentlist"
                  :key="index"
                >
                  <div class="pagination-circle">
                    <strong> {{ paginate(index, limit, page - 1) }}</strong>
                  </div>
                  <a href="#">
                    <b-row>
                      <b-col sm="12" lg="6" md="12">
                        <p style="font-weight: bold">
                          {{
                            ennounsment[$localeKey('yurDepartmentName')]
                          }}
                        </p>
                        <h2>
                          <b-row>
                            <b-col>
                              <p style="font-size: 16px">
                                <span style="font-weight: bold"
                                  >{{ $t("numberAnnounsment") }}:</span
                                >
                                {{ ennounsment.regNumber }}
                              </p>
                            </b-col>
                            <b-col> </b-col>
                          </b-row>
                        </h2>
                      </b-col>
                      <b-col sm="12" lg="3" md="12">
                        <h5 class="mb-3" style="font-weight: bold">
                          <i class="fas fa-user-tie mr-2"></i>
                          {{ $t("home.lavozim") }}:
                          <b-badge variant="primary" c>{{
                            ennounsment.countPosition
                          }}</b-badge>
                        </h5>
                        <h5
                          class="mb-3"
                          style="font-weight: bold"
                          v-if="ennounsment.yurDepartmentPhone"
                        >
                          <i class="fas fa-phone mr-2"></i>
                          {{ ennounsment.yurDepartmentPhone }}
                        </h5>
                      </b-col>
                      <b-col sm="12" lg="3" md="12">
                        <h5 class="mb-3" style="font-weight: bold">
                          <i class="fas fa-bullhorn mr-2"></i>
                          {{ $t("home.vacancy") }}:
                          <b-badge variant="primary">{{
                            ennounsment.sumVacancy
                          }}</b-badge>
                        </h5>
                        <h5
                          v-if="ennounsment.yurDepartmentEmail"
                          class="mb-3"
                          style="
                            font-weight: bold;
                            max-width: 300px;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;
                          "
                        >
                          <i class="fas fa-envelope mr-2"></i>
                          {{ ennounsment.yurDepartmentEmail }}
                        </h5>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-badge
                        class="m-1"
                        v-for="(ennounsment, i) in positionNames[index]"
                        :key="i"
                        variant="warning"
                      >
                        {{ ennounsment }}
                      </b-badge>
                    </b-row>
                  </a>
                </li>
              </ol>
            </main>
          </b-overlay>
        </b-col>
      </b-row>
    </div>
    <div v-else class="m-4">
      <b-card>
        <h5>{{ $t("warning.noInformation") }}</h5>
      </b-card>
    </div>
    <b-pagination
      class="m-0"
      :total-rows="ennounsmentlistTotal"
      :per-page="limit"
      v-model="page"
      :prev-text="$t('actions.prev')"
      :next-text="$t('actions.next')"
      hide-goto-end-buttons
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import EnnounsmentService from "@/services/vacancy/announsment.servise";

export default {
  props: {
    isArchive: {},
  },
  data() {
    return {
      loading: false,
      total: 0,
      page: 1,
      limit: 20,
      positionNames: [],
      options: [],
      depId: "",
      staffPositionId: "",
      locationTypeId: "",
      data: {
        page: this.page - 1,
        limit: this.limit,
      },
    };
  },
  components: {},
  watch: {
    page: {
      async handler() {
        await this.getList();
      },
    },
    async staffPositionId(staffPositionId) {
      await this.getDefaultAnnouncment({
        params: {
          params: {
            page: this.page - 1,
            limit: this.limit,
          },
          depId: this.depId,
          staffPositionId: this.staffPositionId,
          locationTypeId: this.locationTypeId,
        },
        isArchive: this.isArchive,
      });
    },
    async locationTypeId(locationTypeId) {
      await this.getDefaultAnnouncment({
        params: {
          params: {
            page: this.page - 1,
            limit: this.limit,
          },
          depId: this.depId === null ? "" : this.depId,
          staffPositionId:
            this.staffPositionId === null ? "" : this.staffPositionId,
          locationTypeId: locationTypeId === null ? "" : locationTypeId,
        },
        isArchive: this.isArchive,
      });
    },
    ennounsmentlist: {
      async handler(newValue) {
        this.positionNames = [];

        for (let i = 0; i < this.ennounsmentlist.length; i++) {
          let ennounsment = this.ennounsmentlist[i];
          let arr;
          if (this.$i18n.locale === "lt") {
            arr = ennounsment.positionNameLt
              .replace("{", "")
              .replace("}", "")
              .split(",");
          }
          if (this.$i18n.locale === "uz") {
            arr = ennounsment.positionNameUz
              .replace("{", "")
              .replace("}", "")
              .split(",");
          }
          if (this.$i18n.locale === "ru") {
            arr = ennounsment.positionNameRu
              .replace("{", "")
              .replace("}", "")
              .split(",");
          }

          let inArr = [];

          for (let j = 0; j < arr.length; j++) {
            inArr[j] = arr[j].replace(/"/gi, "");
          }
          this.positionNames.push(inArr);
          inArr = [];
          // this.positionNames[i] =
        }
      },
    },
  },
  computed: {
    ...mapState("ennounsment", {
      ennounsmentlist:  "list",
      ennounsmentlistTotal: "total",
      listStaffPosition: "listStaffPosition",
      totalStaffPosition: "totalStaffPosition",
      listLocationType: "listLocationType",
      totalLocationType: "totalLocationType",
    }),
   
  },
  methods: {
    paginate(index, page_size, page_number) {
      // --page_size;
      return page_number * page_size + index + 1;
    },
    ...mapActions("ennounsment", {
      getDefaultAnnouncment: "getList",
      getListLocationType: "getListLocationType",
      getListStaffPosition: "getListStaffPosition",
    }),
    async getList() {
      this.loading = true;
      let action = this.isArchive ? "getArchiveList" : "getList";
      await EnnounsmentService[action]({
        params: {
          page: this.page - 1,
          limit: this.limit,
        },
        depId: this.depId === null ? "" : this.depId,
        staffPositionId:
          this.staffPositionId === null ? "" : this.staffPositionId,
        locationTypeId: this.locationTypeId === null ? "" : this.locationTypeId,
      }).then((res) => {
        this.$nextTick(() => {
            this.$store.commit("ennounsment/setListResponse", res);
          this.loading = false;
        });
      });
    },
    async fetchLocationType(search, loading) {
      this.params.search[this.$localeKey()] = search;
      await this.listLocationType(this.params);
    },
    async fetchStaffPosition(search, loading) {
      this.params.search[this.$localeKey()] = search;
      await this.listLocationType(this.params);
    },
    vacancyPage(id) {
    if(this.isArchive){
        this.$router.push("/vacancy/" + id+"?archive=archive-vacancy");
    }
    else {
        this.$router.push("/vacancy/" + id);
    }
    },
  },
  async created() {
    await this.getDefaultAnnouncment({
      params: {
        params: {
          page: this.page - 1,
          limit: this.limit,
        },
        depId: this.depId,
        staffPositionId: this.staffPositionId,
        locationTypeId: this.locationTypeId,
      },
      isArchive: this.isArchive,
    });
    await this.getListLocationType();
    await this.getListStaffPosition();
  },
  mounted() {},
};
</script>
<style lang="scss">
//@import url(https://fonts.googleapis.com/css?family=Montserrat:900|Raleway:400,400i,700,700i);

/*** VARIABLES ***/
/* Colors */
$black: #1d1f20;
$blue: #83e4e2;
$green: #ffffff;
$yellow: #d40dea;
$white: #fafafa;

/*** EXTEND ***/
/* box-shadow */
%boxshadow {
  box-shadow: 0.25rem 0.25rem 0.6rem rgba(0, 0, 0, 0.05),
    0 0.5rem 1.125rem rgba(75, 0, 0, 0.05);
}

/*** STYLE ***/
*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  background-color: $white;
  color: $black;
  font-family: "Raleway", sans-serif;
}

main {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  padding: 1rem;
}

.style-v {
  background: white;
  .vs__dropdown-toggle {
    // height: 60px;

    // border-radius: 7px ;
    border: none;
    box-shadow: 0.25rem 0.25rem 0.6rem rgba(0, 0, 0, 0.05),
      0 0.5rem 1.125rem rgba(75, 0, 0, 0.05);
  }
}

ol.gradient-list {
  counter-reset: gradient-counter;
  list-style: none;
  padding: 0px;

  > li {
    background: white;
    border-radius: 0 0.5rem 0.5rem 0.5rem;
    @extend %boxshadow;
    counter-increment: gradient-counter;
    margin-top: 1rem;
    min-height: 2rem;
    padding: 1rem 1rem 1rem 3rem;
    position: relative;

    &::before,
    &::after {
      // background: linear-gradient(135deg, $blue 0%, $green 100%);
      // border-radius: 1rem 1rem 0 1rem;
      // content: "";
      // height: 3rem;
      // left: -1rem;
      // overflow: hidden;
      // position: absolute;
      // top: -1rem;
      // width: 3rem;
    }

    &::before {
      // align-items: flex-end;
      // @extend %boxshadow;
      // content: counter(gradient-counter);
      // color: $black;
      // display: flex;
      // font: 900 1.5em/1 "Montserrat";
      // justify-content: flex-end;
      // padding: 0.125em 0.25em;
      // z-index: 1;
    }

    @for $i from 1 through 5 {
      &:nth-child(10n + #{$i}):before {
        background: linear-gradient(
          135deg,
          rgba($green, $i * 0.2) 0%,
          rgba($yellow, $i * 0.2) 100%
        );
      }
    }
    @for $i from 6 through 10 {
      &:nth-child(10n + #{$i}):before {
        background: linear-gradient(
          135deg,
          rgba($green, 1 - (($i - 5) * 0.2)) 0%,
          rgba($yellow, 1 - (($i - 5) * 0.2)) 100%
        );
      }
    }

    + li:hover {
      cursor: pointer;
    }

    + li {
      margin-top: 2rem;
    }
  }
}
.pagination-circle {
  position: absolute;
  width: 45px;
  height: 45px;
  background: #548cff;
  top: -10px;
  left: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: white;
}
.badge-warning {
  white-space: normal!important;
}
</style>
